// @ts-nocheck
// TypeScript is ignoring this file. If you are editing this file you must fix the type issues.

import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ArrowRightIcon } from '../../../../../assets/icons/svg/shared/ic-shared-right-arrow.svg';
import { useStore } from '../../../../../store';

interface MenuItem {
  title?: string;
  name: string;
  SVGComponent?: any;
  SVGColor?: string;
  textColor?: string;
  arrowColor?: string;
  testId: string;
  disableForRoles?: string[];
}

interface IPopoverMenu {
  menuItems: MenuItem[];
  onMenuItemClick: (name: string) => void;
  className?: string;
  testId: string;
}

const arrowStyles = 'before:content-none before:w-0 before:h-0 before:border-b-[20px] before:border-x-[20px]';

export const ListMenu = ({ menuItems, onMenuItemClick, className, testId }: IPopoverMenu) => {
  const { t } = useTranslation();
  const summaryData = useStore((state) => state.summary);
  if (!menuItems || menuItems.length === 0) return null;
  const renderSeparator = () => (
    <div className='h-[1px] bg-bw03 my-[4px]' key={`MenuItem-separator-${Math.random()}`} />
  );
  const renderIcon = (SVGComponent: any, isItemDisabled: boolean, SVGColor: string | undefined) => {
    const strokeColor = isItemDisabled ? 'text-bw05' : SVGColor && `${SVGColor}`;
    return SVGComponent && <SVGComponent className={`${strokeColor} ${strokeColor?.replace('stroke', 'text')}`} />;
  };
  const shouldAvoidAction = (item: MenuItem) => {
    if (!item?.disableForRoles?.length) return false;
    return item.disableForRoles.includes(summaryData?.authorizedUserType);
  };
  const onClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>, name: string): void => {
    e.stopPropagation();
    if (onMenuItemClick) onMenuItemClick(name);
  };
  const renderMenuItem = (menuItem: MenuItem) => {
    if (!menuItem.name) return renderSeparator();
    const isItemDisabled = shouldAvoidAction(menuItem);
    const { title, SVGComponent, SVGColor, textColor, name, arrowColor, testId: actionTestId } = menuItem;
    return (
      <button
        disabled={isItemDisabled}
        data-testid={`${actionTestId}`}
        type='button'
        onClick={(e) => onClick(e, name)}
        className={`w-[calc(100%-8px)] mx-[4px] z-50 flex items-center pl-[12px] pr-[12px] h-[40px] group rounded-sm ${isItemDisabled ? 'cursor-not-allowed' : 'cursor-pointer hover:bg-bw02'}`}
        key={`MenuItem-${name}`}
      >
        {renderIcon(SVGComponent, isItemDisabled, SVGColor)}
        {title && (
          <div
            data-testid={`list-menu__button-${name}__title`}
            className={`text-md font-metricR text-bw08 ml-[9px] text-left ${isItemDisabled ? 'text-bw05' : textColor || ''}`}
          >
            {t(title)}
          </div>
        )}
        <ArrowRightIcon
          className={`w-[16px] h-[16px] ml-[auto] opacity-0 ${isItemDisabled ? '' : 'group-hover:opacity-100'} ${arrowColor || 'text-bw07'}`}
        />
      </button>
    );
  };
  const itemsToRender = menuItems.map(renderMenuItem);
  return (
    <div
      data-testid={testId}
      className={`rounded bg-bw00 z-[100] relative py-[4px] box-border ${className ?? ''} ${arrowStyles} `}
    >
      {itemsToRender}
    </div>
  );
};
